import React from 'react';

interface HeroProps {
  title?: string;
  subtitle?: string;
  videoUrl?: string;
  imageUrl?: string;
  ctaText?: string;
  ctaUrl?: string;
  height?: 'full' | 'large' | 'medium';
  overlay?: boolean;
}

export const Hero: React.FC<HeroProps> = ({
  title = 'Peak Roofers San Diego',
  subtitle = 'Expert Roofing Solutions for Your Home',
  videoUrl,
  imageUrl,
  ctaText = 'Get Free Quote',
  ctaUrl = '/contact',
  height = 'full',
  overlay = true
}) => {
  const heightClass = {
    full: 'nai-hero--full',
    large: 'nai-hero--large',
    medium: 'nai-hero--medium'
  }[height];

  return (
    <section className={`nai-hero ${heightClass}`}>
      {videoUrl && (
        <video
          className="nai-hero__video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      )}

      {imageUrl && !videoUrl && (
        <div
          className="nai-hero__image"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
      )}

      {overlay && <div className="nai-hero__overlay" />}

      <div className="nai-hero__content">
        <div className="nai-hero__container">
          {title && (
            <h1 className="nai-hero__title">{title}</h1>
          )}
          {subtitle && (
            <p className="nai-hero__subtitle">{subtitle}</p>
          )}
          {ctaText && (
            <a href={ctaUrl} className="nai-hero__cta">
              {ctaText}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};